import React from 'react'
import { MdDevices } from "react-icons/md";
import { BsFastForwardCircle } from "react-icons/bs";
import { IoGameControllerOutline } from "react-icons/io5";
import { LuFileStack } from "react-icons/lu";
import { MdOutlineCloudDone } from "react-icons/md";
import { motion } from 'framer-motion';
import PlanCard from './PlanCard';
function Plans({connection, setConnection}) {
   
    const plans= [
        {
        title: "Basic Plan",
        speed: "30 Mbps",
        prices: {
            "12": 4500,
            "3": 1400,
            "1": 550
        },
        features: [
        { icon: <MdDevices className="text-blue-950" size={25} />, text: "Connect upto 4 smart devices" },
        { icon: <BsFastForwardCircle className="text-blue-950" size={25} />, text: "Seamless HD streaming and video calls" },
        { icon: <IoGameControllerOutline className="text-blue-950" size={25} />, text: "High performance online gaming" },
      ],
    },
    {
        title: "Standard Plan",
        speed: "50 Mbps",
        prices: {
            "12": 7000,
            "3": 1700,
            "1": 650
        },
        features: [
        { icon: <MdDevices className="text-blue-950" size={25} />, text: "Connect upto 6 smart devices" },
        { icon: <BsFastForwardCircle className="text-blue-950" size={25} />, text: "Seamless FHD streaming and video calls" },
        { icon: <IoGameControllerOutline className="text-blue-950" size={25} />, text: "High performance online gaming" }
        ]
    },
    {
        title: "Premium Plan",
        speed: "100 Mbps",
        prices: {
            "12": 10500,
            "3": 2800,
            "1": 800
        },
        features: [
        { icon: <LuFileStack className="text-blue-950" size={25}/>, text: "Download and upload large files"},
        { icon: <MdDevices className="text-blue-950" size={25} />, text: "Connect upto 9 smart devices" },
        { icon: <BsFastForwardCircle className="text-blue-950" size={25} />, text: "Seamless 4K streaming and video calls" },
        { icon: <IoGameControllerOutline className="text-blue-950" size={25} />, text: "High performance online gaming" },
        ]
    },
    {
        title: "Ultimate Plan",
        speed: "200 Mbps",  
        prices: {
            "12": 17500,
            "3": 3300,
            "1": 1760
        },
        features: [
        { icon: <MdOutlineCloudDone className="text-blue-950" size={25} />, text: "Heavy cloud backup and syncing" },
        { icon: <MdDevices className="text-blue-950" size={25} />, text: "Connect unlimited smart devices" },
        { icon: <BsFastForwardCircle className="text-blue-950" size={25} />, text: "Ultra HD streaming across multiple screens" },
        { icon: <IoGameControllerOutline className="text-blue-950" size={25} />, text: "Zero-lag gaming and streaming" },
        ]
    }
    ]
  
  return (
    <div name="plans" className="max-w-6xl mx-auto my-10">
        <motion.h2 className="text-4xl text-blue-950 text-center m-4 font-semibold font-poppins cursor-default"  initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}>Internet Plans</motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 p-4">
            {plans.map((plan, index) => (
             <PlanCard key={index} title={plan.title} speed={plan.speed} prices={plan.prices} connection={connection} setConnection={setConnection} features={plan.features} />))}
    </div>
    </div>
  )
}

export default Plans;